module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAOVBMVEUAAAA7iMM7iMM7iMPdLkTdLkTdLkTdLkQ7iMM7iMPdLkTdLkQ7iMPdLkS73fXu7u7u7u7t3uDu7u7r5B3uAAAAE3RSTlMAYL///79gACDPzyDv7///YL8AGxeMcwAAAJlJREFUeAHt1zEWhCAMhOFoRqOwLrj3P+ziBZgmhS8vX0P3N0wTSSmuZdUpTG27DWJ2nEqAKPUJHR9lwFx1hE6lQBWTRVW/g07exnVZfUK3qE+o+YZmkQfABQ6979dyR7mjsCEO4CKHmpPIITiJHMod5Y5i7uhuLm7pzUWXX4GDYmL1wkDxM8tqATh++A37Boqfog5eF8pQhv4LVI88awnBxQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f1fa-1f1f8.png
// module id = 615
// module chunks = 0